import state from './overviewState';

export const mutations = {
    updateSelectedTab(state, newTab) {
        localStorage.setItem(`defaultTab:${state.identity.type}`, newTab);
        state.tabSelected = newTab;
    },

    updateMainContact(state, contact) {
        contact.mainContact = true;
        state.mainContact = [contact];
    },

    updateMainContactDunning(state, contact) {
        if (state.mainContact[0].id == contact.id) {
            state.mainContact[0].mainContactDunning = true;
        }
    },

    setAvatar(state, avatar) {
        state.avatar = avatar;
    },

    storeData(state, data) {
        state.linkedid = data.linkedid;
        state.linkedtype = data.linkedtype;
        state.dataFetch = data.data;
        if (data.data.contacts) {
            state.mainContact = data.data.contacts;
        }
        state.identity = data.data.identity;
        state.avatar = data.data.identity.avatar;
        state.permissions = data.permissions;
        state.dataMap = data.dataMap;
        state.sellsyInformations = data.data.sellsy;
        state.tags = data.data.tags;
        if (data.data.favorites && data.data.favorites.items) {
            state.setDefaultFavorite = data.data.favorites.useDefault;
            if (state.setDefaultFavorite) {
                state.activeFavorites = state.defaultFavorite;
            } else {
                state.activeFavorites = data.data.favorites.items;
            }
        }
        const step = data.data.informations.find((index) => index.key == 'stepId');
        if (step) {
            state.activeStep = step.value - 1;
        }
        state.routes = data.routes;
        state.availableStatCards = data.availableStatCards;
        state.currencies = data.data.currencies;
        state.databots = data.databots;
        state.agendaViewConfig = data.agendaViewConfig;
    },

    updateInformations(state, data) {
        state.dataFetch.informations = data;
    },
    updateSellsyInformations(state, data) {
        state.sellsyInformations = data;
    },
    updateContacts(state, data) {
        state.dataFetch.contacts = data;
        state.mainContact = data;
    },
    updateThird(state, data) {
        state.dataFetch.third = data;
    },
    addFavorite(state, item) {
        state.activeFavorites.push(item.favoriteName);
        state.favorites.push(item);
    },
    removeFavorite(state, itemToRemove) {
        state.activeFavorites = state.activeFavorites.filter(
            (fav) => fav !== itemToRemove.favoriteName,
        );
        state.favorites = state.favorites.filter(
            (item) => item.favoriteName !== itemToRemove.favoriteName,
        );
    },
    buildFavorites() {},
    resetFavorites(state) {
        state.favorites = [];
    },
    updateTags(state, data) {
        state.tags = data;
    },
    updateOpportunityStepId(state, data) {
        const stepId = state.dataFetch?.informations?.findIndex((index) => index.key === 'stepId');
        if (stepId) {
            state.dataFetch.informations[stepId].value = data;
        }
    },
    updateOwner(state, data) {
        state.sellsyInformations.owner = {
            ...state.sellsyInformations.owner,
            ...data,
        };
    },
    updateName(state, data) {
        const name = state.dataFetch?.informations?.find((index) => index.key === 'name').value;

        if (name) {
            state.dataFetch.informations.find((index) => index.key === 'name').value = data;
            state.identity.name = data;
        }
    },
};

export const actions = {
    storeData({ commit }, data) {
        commit('storeData', data);
    },
    buildFavorites({ commit, getters }) {
        commit('resetFavorites');
        commit('buildFavorites', { getters });
    },
    updateSelectedTab({ commit }, selectedTab) {
        commit('updateSelectedTab', selectedTab);
    },
    updateMainContact({ commit }, contact) {
        commit('updateMainContact', contact);
    },
    updateMainContactDunning({ commit }, contact) {
        commit('updateMainContactDunning', contact);
    },
    setAvatar({ commit }, avatar) {
        commit('setAvatar', avatar);
    },
    updateInformations({ commit }, data) {
        commit('updateInformations', data);
    },
    updateSellsyInformations({ commit }, data) {
        commit('updateSellsyInformations', data);
    },
    updateContacts({ commit }, data) {
        commit('updateContacts', data);
    },
    updateThird({ commit }, data) {
        commit('updateThird', data);
    },
    updateFavorites({ state, commit }, payload) {
        let processAjaxCall = false;
        if (state.activeFavorites.includes(payload.item.favoriteName)) {
            commit('removeFavorite', payload.item);
            processAjaxCall = true;
        } else {
            if (state.activeFavorites.length <= state.favLimit) {
                commit('addFavorite', payload.item);
                processAjaxCall = true;
            } else {
                Push.error(Loc.g('Vous avez atteint la limite du nombre de favoris'));
            }
        }

        if (processAjaxCall) {
            SellsyJS.WebServiceCaller.put(
                payload.route,
                {},
                state.activeFavorites,
                () => {},
                () => {
                    Push.error(Loc.g("Une erreur est survenue lors de l'enregistrement du favori"));
                },
            );
        }
    },
    updateTags({ commit }, data) {
        commit('updateTags', data);
    },
    updateOpportunityStepId({ commit }, data) {
        commit('updateOpportunityStepId', data);
    },
    updateOwner({ commit }, data) {
        commit('updateOwner', data);
    },
    updateName({ commit }, data) {
        commit('updateName', data);
    },
};

export const getters = {
    tabSelected: (state) => {
        return state.tabSelected;
    },
    linkedid: (state) => {
        return state.linkedid;
    },
    linkedtype: (state) => {
        return state.linkedtype;
    },
    dataFetch: (state) => {
        return state.dataFetch;
    },
    favorites: (state) => {
        return state.favorites;
    },
    identity: (state) => {
        return state.identity;
    },
    avatar: (state) => {
        return state.avatar;
    },
    mainContact: (state) => {
        return state.mainContact[0];
    },
    timeline: (state) => {
        return state.timeline;
    },
    permissions: (state) => {
        return state.permissions;
    },
    dataMap: (state) => {
        return state.dataMap;
    },
    sellsyInformations: (state) => {
        return state.sellsyInformations;
    },
    tags: (state) => {
        return state.tags;
    },
    activeFavorites: (state) => {
        return state.activeFavorites;
    },
    routes: (state) => {
        return state.routes;
    },
    availableStatCards: (state) => {
        return state.availableStatCards;
    },
    currencies: (state) => {
        return state.currencies;
    },
    databots: (state) => {
        return state.databots;
    },
    agendaViewConfig: (state) => {
        return state.agendaViewConfig;
    },
    owner: (state) => {
        return state.sellsyInformations.owner;
    },
};

export default {
    state() {
        return JSON.parse(JSON.stringify(state));
    },
    mutations: mutations,
    actions: actions,
    getters: getters,
};
